import styles from './DividerHorizonal.module.css';

export default function DividerHorizental() {
  return <hr className={styles.divider} />;
}
